import { useState } from 'react';
import { ShowPageLayout } from 'framework/ui/layout';
import { useVacancyGroupId } from 'domain/recruiting/newVacancy/routing';
import VacancyGroupInfo from './VacancyGroupInfo';
import VacancyGroupTabContent from './VacancyGroupTabContent';
import { Outlet, useLocation } from 'react-router-dom';
import { VacancyContextProvider } from 'domain/recruiting/newVacancy/VacancyContext';
import GenerateLinkForSycomButton from 'domain/recruiting/newVacancy/shared/button/GenerateLinkForSycomButton';
import { FormShowTemplate } from 'framework/form';
import VacancyGroupBreadcrumbs from './shared/VacancyGroupBreadcrumbs';
import useVacancyGroupBreadcrumbsMenu from './shared/useVacancyGroupBreadcrumbsMenu';
import DirectLinkForSycomButton from '../../shared/button/DirectLinkForSycomButton';
import { useVacancyGroupService } from 'domain/shared/newVacancy';

const ViewVacancyGroup = () => {
  const id = useVacancyGroupId()!;
  const { getVacancyGroupById, visitGroup, updateVacancyGroup, mapDataForForm } = useVacancyGroupService();
  const [areVacanciesUpdated, setAreVacanciesUpdated] = useState(false);
  const [arePublicationsUpdated, setArePublicationsUpdated] = useState(false);

  const location = useLocation();
  const vacancyGroupTabs = useVacancyGroupBreadcrumbsMenu();

  const getTabByLabel = (label: string) => vacancyGroupTabs.find(option => option.label === label)?.label;

  const currentTab =
    vacancyGroupTabs.findLast(({ value }) => location.pathname.includes(String(value)))?.label ||
    getTabByLabel('Information');

  return (
    <FormShowTemplate
      getDataFunc={async () => {
        await visitGroup(id);
        return getVacancyGroupById(id);
      }}
      submitFormFunc={values => updateVacancyGroup(id, values)}
      mapDataForForm={mapDataForForm}
      afterSubmit={{
        message: 'You are awesome! The Vacancy Group has been successfully updated.',
      }}
    >
      <VacancyContextProvider
        value={{
          areVacanciesUpdated,
          arePublicationsUpdated,
          setAreVacanciesUpdated,
          setArePublicationsUpdated,
        }}
      >
        <ShowPageLayout
          hasSeparateSections
          breadcrumbs={<VacancyGroupBreadcrumbs entity={currentTab} tabs={vacancyGroupTabs} />}
          breadcrumbsButtons={[<DirectLinkForSycomButton />, <GenerateLinkForSycomButton isUsingFromVacancyPage />]}
        >
          <VacancyGroupInfo />
          <VacancyGroupTabContent>
            <Outlet />
          </VacancyGroupTabContent>
        </ShowPageLayout>
      </VacancyContextProvider>
    </FormShowTemplate>
  );
};

export default ViewVacancyGroup;
